import NullCheckUtil from './NullCheckUtil';

class FormatUtil {
    static phoneFormatter(telNumber) {
        if (NullCheckUtil.isNotEmpty(telNumber) && telNumber.length == 11) {
            return telNumber.substring(0, 3) + '-' + telNumber.substring(3, 7) + '-' + telNumber.substring(7, 11);
        } else {
            return telNumber;
        }
    }

    static telNoFormatter(telNumber) {
        if (NullCheckUtil.isNotEmpty(telNumber)) {
            if (telNumber.startsWith('02', 0) && telNumber.length == 9) {
                // 02-123-4567
                return telNumber.substring(0, 2) + '-' + telNumber.substring(2, 5) + '-' + telNumber.substring(5, 9);
            } else if (telNumber.startsWith('02', 0) && telNumber.length == 10) {
                // 02-1234-5678
                return telNumber.substring(0, 2) + '-' + telNumber.substring(2, 6) + '-' + telNumber.substring(6, 10);
            } else if (telNumber.length == 10) {
                // 010-123-4567
                return telNumber.substring(0, 3) + '-' + telNumber.substring(3, 6) + '-' + telNumber.substring(6, 10);
            } else if (telNumber.length == 11) {
                // 010-1234-5678
                return telNumber.substring(0, 3) + '-' + telNumber.substring(3, 7) + '-' + telNumber.substring(7, 11);
            }
        }
        return telNumber;
    }

    static removeTelNoFormat(telNumber) {
        return telNumber.replaceAll('-', '').replaceAll('_', '').replaceAll(' ', '');
    }
}

export default FormatUtil;
